import moment from 'moment';

export const getMinDate = () =>
  moment()
    .subtract(5, 'year')
    .startOf('day')
    .toDate();
